import styled from "styled-components";
import account from "../../assets/icons/account.png";
import fipayFonts from "../../theme/index";

export const AccountContainer = styled.div`
  background-image: url("/assets/icons/account.png");
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    padding-top: 80px;
  }
`;

export const CreateAccount = styled.div`
  h4 {
    font-family: GT Walsheim Pro;
    font-size: 45px;
    font-weight: 700;
    margin: 15px;
    letter-spacing: 0.5px;
    text-align: center;
    color: #09005b;
    @media screen and (min-width: 0px) and (max-width: 766px) {
      font-family: GT Walsheim Pro;
      font-size: 26px;
      font-weight: 700;
      line-height: 32px;
      letter-spacing: 0.5px;
      text-align: center;
    }
  }

  p {
    font-family: "GT Walsheim Pro";
    font-weight: 18px;
    letter-spacing: 0.5px;
    color: #5e5e5e;
    @media screen and (max-width: 700px) {
      font-family: GT Walsheim Pro;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.02em;
      text-align: center;
    }
  }
`;

export const AccountBox = styled.div`
  padding: 0 20%;
  margin: 4rem;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    width: 80%;
    padding: 0px;
    margin: 0px;
  }
  @media screen and (min-width: 767px) and (max-width: 1024px) {
    width: 100%;
    padding: 0px;
    margin: 20px;
  }
`;

export const AccountSecondDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;
  text-align: center;
  align-items: center;
  gap: 0;
  @media screen and (max-width: 700px) {
    flex-wrap: wrap;
  }
  div {
    text-align: center;
    margin: 25px 15px;
  }
  h6 {
    font-family: "GT Walsheim Pro";
    font-size: 1.5rem;
    font-weight: bold;
    letter-spacing: 0.5px;
    color: #09005b;
    line-height: 28px;
    margin-bottom: 5px;
    text-align: center;
    @media screen and (max-width: 700px) {
      font-family: GT Walsheim Pro;
      font-size: 18px;
      font-weight: 700;
      line-height: 32px;
      letter-spacing: 0.02em;
      text-align: center;
    }
  }

  p {
    font-family: GT Walsheim Pro;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 2%;
    text-align: left;
    color: #5e5e5e;
    margin-top: 10px;
    @media screen and (max-width: 700px) {
      text-align: center;
    }
  }
`;

export const AccountFirstBox = styled.div`
  display: flex;

  @media screen and (min-width: 0px) and (max-width: 766px) {
    display: grid;
  }
`;

export const AccountSecondBox = styled.div`
  display: flex;

  @media screen and (max-width: 766px) {
    display: grid;
  }
`;
export const AccountImgOne = styled.div`
  .img_1 {
    margin-top: -130px;
    margin-left: 0;
    @media screen and (max-width: 766px) {
      margin-top: 30px;
      margin-left: 50px;
    }
    @media screen and (min-width: 767px) and (max-width: 1024px) {
      margin-right: 50px;
    }
  }

  .img_3 {
    margin-top: -130px;
    margin-left: -30px;
    @media screen and (max-width: 766px) {
      margin-left: 40px;
      margin-top: 20px;
    }
    @media screen and (min-width: 767px) and (max-width: 1024px) {
      margin-right: 60px;
    }
  }
`;

export const AccountImgTwo = styled.div`
  .img_2 {
    margin-left: 80px;
    @media screen and (max-width: 766px) {
      margin: 0px;
      margin-top: 20px;
    }
    @media screen and (min-width: 767px) and (max-width: 1024px) {
      margin-right: 40px;
    }
  }
  .img_4 {
    margin-left: 25px;
    @media screen and (max-width: 766px) {
      margin-left: 40px;
    }
    @media screen and (min-width: 767px) and (max-width: 1024px) {
      margin-right: 50px;
    }
  }
`;

export const CreateCurve = styled.div`
  display: flex;
  margin: 20px;
  gap: 50px;

  @media screen and (min-width: 0px) and (max-width: 766px) {
    display: grid;
    margin: 0px;
  }
  @media screen and (min-width: 767px) and (max-width: 1024px) {
    display: grid;
    border: 1px solid red;
  }

  img {
    @media screen and (max-width: 766px) {
      display: none;
    }
  }
  .AccountImgFirstDiv {
    @media screen and (min-width: 767px) and (max-width: 1024px) {
      margin-bottom: 70px;
      background-color: red;
    }
  }
`;

export const CreateGuideOne = styled.div`
  .an_account {
    font-family: GT Walsheim Pro;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-align: left;
    color: #09005b;
    margin-top: 20px;
    @media screen and (min-width: 0px) and (max-width: 766px) {
      margin-top: -40px;
      font-family: GT Walsheim Pro;
      font-size: 18px;
      font-weight: 700;
      line-height: 32px;
      letter-spacing: 0.02em;
      text-align: center;
    }
  }
  .click_create {
    font-family: GT Walsheim Pro;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.02em;
    text-align: left;
    margin-top: -35px;
    color: #5e5e5e;
    @media screen and (min-width: 0px) and (max-width: 766px) {
      font-family: GT Walsheim Pro;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.02em;
      text-align: center;
    }
  }
  .verify_confirm {
    font-family: GT Walsheim Pro;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: #09005b;
    margin-top: 20px;
    @media screen and (min-width: 0px) and (max-width: 766px) {
      font-size: 18px;
      font-weight: 700;
      margin-top: -70px;
    }
  }

  .confirm_email {
    font-family: GT Walsheim Pro;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.02em;
    text-align: left;
    margin-top: -35px;
    margin-left: 40px;
    color: #5e5e5e;
    @media screen and (min-width: 0px) and (max-width: 766px) {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: #5e5e5e;
    }
  }
`;
export const CreateGuideTwo = styled.div`
  .fill_details {
    font-family: GT Walsheim Pro;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-align: left;
    color: #09005b;
    margin-left: 45px;
    margin-top: 10px;
    @media screen and (min-width: 0px) and (max-width: 766px) {
      margin-top: -40px;
      font-family: GT Walsheim Pro;
      font-size: 18px;
      font-weight: 700;
      line-height: 32px;
      letter-spacing: 0.02em;
      margin-left: 70px;
    }
  }
  .relevant_details {
    font-family: GT Walsheim Pro;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.02em;
    text-align: left;
    margin-top: -45px;
    margin-left: 45px;
    color: #5e5e5e;
    @media screen and (min-width: 0px) and (max-width: 766px) {
      font-family: GT Walsheim Pro;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.02em;
    }
  }
  .get_started {
    font-family: GT Walsheim Pro;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-align: left;
    color: #09005b;
    margin-left: 95px;
    margin-top: 10px;
    @media screen and (min-width: 0px) and (max-width: 766px) {
      font-family: GT Walsheim Pro;
      font-size: 18px;
      font-weight: 700;
      line-height: 32px;
      letter-spacing: 0.02em;
      margin-top: -40px;
    }
  }
  .enjoy_explore {
    font-family: GT Walsheim Pro;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.02em;
    text-align: left;
    margin-top: -45px;
    margin-left: 85px;
    color: #5e5e5e;
    @media screen and (min-width: 0px) and (max-width: 766px) {
      font-family: GT Walsheim Pro;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.02em;
      text-align: center;
      margin-left: 30px;
    }
  }
`;
export const CreateCircle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12rem;
  position: absolute;
  margin-top: 3%;
  margin-left: 4%;
  @media screen and (min-width: 1024px) {
    margin-left: 60px;
  }

  @media screen and (max-width: 700px) {
    display: none;
    position: relative;
    margin: 0px;
  }

  span {
    width: 130px;
    height: 130px;
    border-radius: 50%;
    text-align: center;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 766px) {
      width: 70px;
      height: 70px;
    }
  }
  span:first-child {
    background-color: #322a76;
    color: #ffffff;
    box-shadow: 0px 29px 50px 0px rgba(50, 50, 50, 0.3);
    font-family: GT Walsheim Pro;
    font-size: 50px;
    font-weight: 700;
    line-height: 100px;
    letter-spacing: 0.015em;
    text-align: center;

    @media screen and (max-width: 766px) {
      font-size: 25px;
      font-weight: 350;
      line-height: 50px;
      text-align: center;
      font-family: Satoshi;
    }
  }

  span:last-child {
    background-color: #ceccde;
    color: #09005b;
    box-shadow: 0px 29px 50px 0px rgba(50, 50, 50, 0.3);
    font-family: Inter;
    font-size: 50px;
    font-weight: 700;
    line-height: 100px;
    letter-spacing: 0.015em;
    text-align: center;
  }
`;

export const AccountButton = styled.button`
  padding: 0 5%;
  border: none;
  background-color: #00c7031a;
  border-radius: 30px;

  .btn_creation {
    color: #00c703;
    font-family: GT Walsheim Pro;
    font-size: 12px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.02em;
    text-align: center;
    @media screen and (min-width: 0px) and (max-width: 766px) {
      font-family: GT Walsheim Pro;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 0.02em;
      text-align: center;
    }
  }
  @media screen and (min-width: 0px) and (max-width: 766px) {
    width: 60%;
    margin: 20px;
  }
`;

export const AccountCurve = styled.div`
  padding: 0 20%;
  margin: 4rem;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    width: 80%;
    padding: 0px;
    margin: 0px;
  }
`;

export const AccountIn = styled.div`
  .mobile {
    display: none;
  }

  @media screen and (max-width: 700px) {
    width: 100%;
    height: 270px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .mobile {
      display: flex;
    }
    img {
      display: grid;
      margin: 20px 45px;
      padding: 0;
    }
    .first_span {
      background-color: #322a76;
      color: #ffffff;
      width: 80px;
      height: 80px;
      box-shadow: 0px 29px 50px 0px rgba(50, 50, 50, 0.3);
      font-size: ${fipayFonts.fipayFonts.fontSize.heading2};
      font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
      line-height: 50px;
      border-radius: 50%;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
    }

    .second_span {
      background-color: #ceccde;
      color: #09005b;
      width: 80px;
      height: 80px;
      box-shadow: 0px 29px 50px 0px rgba(50, 50, 50, 0.3);

      font-size: ${fipayFonts.fipayFonts.fontSize.heading2};
      font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
      border-radius: 50%;
      line-height: 100px;
      letter-spacing: 0.015em;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: -50px;
    }
    .third_span {
      background-color: #322a76;
      color: #ffffff;
      width: 80px;
      height: 80px;
      box-shadow: 0px 29px 50px 0px rgba(50, 50, 50, 0.3);
      font-size: ${fipayFonts.fipayFonts.fontSize.heading2};
      font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
      line-height: 50px;
      border-radius: 50%;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: -100px;
    }
    .fourth_span {
      background-color: #ceccde;
      color: #09005b;
      width: 80px;
      height: 80px;
      box-shadow: 0px 29px 50px 0px rgba(50, 50, 50, 0.3);
      font-family: Inter;
      font-size: ${fipayFonts.fipayFonts.fontSize.heading2};
      font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
      border-radius: 50%;
      line-height: 100px;
      letter-spacing: 0.015em;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;
